import { elevenlabsModels } from './models/elevenlabs';
import { alibabaModels } from './models/alibaba';
import { minimaxModels } from './models/minimax';
import { sunoModels } from './models/suno';
import { googleModels } from './models/google';
import { bytedanceModels } from './models/bytedance';
import { murekaModels } from './models/mureka';
import type { TersaSpeechModel } from './types';
import { withModelIds } from '@flowmuse/models/shared/with-model-ids';

export type { TersaSpeechModel } from './types';

export const speechModels: Record<string, TersaSpeechModel> = withModelIds({
  ...elevenlabsModels,
  ...alibabaModels,
  ...minimaxModels,
  ...sunoModels,
  ...googleModels,
  ...bytedanceModels,
  ...murekaModels,
});
